import { useParams } from 'react-router-dom';

import KidsView from './KidsView';
import StudentsView from './StudentsView';

const FormScreen = () => {
  const { id, type } = useParams();
  if (type === 'nursery') {
    return <KidsView project={id} />
  } else if (type === 'school') {
    return <StudentsView project={id} />;
  }
};

export default FormScreen;
